import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { format, parse } from 'date-fns';
import {
  Container, Label, Input, Error,
} from './css';

const DATE_FORMAT_PATTERN = 'yyyy-MM-dd';
const REFERENCE_DATE = new Date(2000, 0, 1);

const toDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const parsed = parse(value, DATE_FORMAT_PATTERN, REFERENCE_DATE);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const DatePicker = ({
  input,
  label,
  initialDate,
  maxDate,
  meta: { touched, error } = {},
}) => {
  const { value, onChange, ...inputRest } = input;

  const selectedDate = useMemo(() => toDate(value), [value]);

  const handleChange = useCallback(
    (date) => onChange(format(date, DATE_FORMAT_PATTERN)),
    [onChange],
  );

  return (
    <Container>
      <Label>{label}</Label>
      <ReactDatePicker
        {...inputRest}
        selected={selectedDate}
        onChange={handleChange}
        customInput={<Input type="text" />}
        dateFormat={DATE_FORMAT_PATTERN}
        showYearDropdown
        showMonthDropdown
        closeOnScroll
        placeholderText="yyyy-mm-dd"
        popperPlacement="bottom-center"
        minDate={initialDate || null}
        maxDate={maxDate || null}
      />
      {(touched && error) && (
      <Error>{error}</Error>
      )}
    </Container>
  );
};

DatePicker.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  initialDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default DatePicker;
